import Layout from '@/views/layout'

export default [
  {
    path: '/brandPass',
    name: 'brandPass',
    redirect: '/brandPass/index',
    component: Layout,
    meta: {
      title: '能链品牌通',
      icon: 'vipMarket.png',
      index: 2
    },
    children: [
      {
        path: 'index',
        name: 'index',
        meta: {
          title: '能链品牌通'
        },
        component: () => import('@/views/brandPass')
      }
    ]
  }
]
